module.exports = __webpack_public_path__ + "static/media/rahavard.76a1a41c.jpg";